import { render, staticRenderFns } from "./CampaignUi.vue?vue&type=template&id=e5c8b3d4&lang=pug"
import script from "./CampaignUi.vue?vue&type=script&lang=js"
export * from "./CampaignUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports